export enum ChangeType {
    INSERT = "INSERT",
    UPDATE = "UPDATE",
    DELETE = "DELETE"
};

export interface Error {
    label: string
    data: Array<String>
};